
// Make sure to define REACT_APP_BACKEND_SERVER and REACT_APP_TOKEN in your .env file
const config = {
    // basename: set only at build time. Do not add '/' at the end. Use '' instead of '/'.
    basename: '',
    defaultPath: '/dashboard/jobs',
    fontFamily: "'Poppins', sans-serif",
    borderRadius: 12,
    API_SERVER: process.env.REACT_APP_BACKEND_SERVER,
    TOKEN: process.env.REACT_APP_TOKEN
};

export default config;
